import React from "react"
import './AppFeature.css'

function AppFeature(props) {
    return (
        <figure class="grid__box isDesktop fat-box--left v-scroll-reveal"  
        data-sr-id="3">
          <picture class="grid__game-image isDesktop"  >
            <source srcset={props.previewSrc} type="image/webp" />
            <source srcset={props.previewSrc} type="image/jpeg" />
            <img src={props.previewSrc} alt={props.title} class="image"/>
          </picture>

          <figcaption class="grid__overlay" >
            <picture class="overlay__icon isDesktop overlay__icon--fat-box"  >
              <source srcset={props.iconSrc} type="image/webp" />
              <source srcset={props.iconSrc} type="image/jpeg" />
              <img src={props.iconSrc} alt={props.title} class="image_icon"/>
            </picture>

            <span class="overlay__title isDesktop overlay__title--fat-box" >{props.title}</span>
            <div class="overlay__description isDesktop overlay__description--fat-box" >
              <p class="description__downloads-number isDesktop" >{props.text1}</p>
              <p class="description__downloads-text isDesktop" >{props.text2}</p>
            </div>

            <div class="overlay__store-buttons" >
              <a href={props.appStore} target="_blank" rel="noopener noreferrer"
              >
                <img src="assets/img/brands/logomark/apple-app-store.svg" alt="app_store"
                class="store-buttons__button isDesktop store-buttons__button--fat-box" />
              </a>
              <a href={props.playStore} target="_blank" rel="noopener noreferrer" class="voodoo-link"
              >
                <img src="assets/img/brands/logomark/google-play-store.svg" alt="play_store"
                class="store-buttons__button isDesktop store-buttons__button--fat-box" />
              </a>
            </div>

          </figcaption>
        </figure>
        
    )
}

export default AppFeature